import React from 'react';
import { isMobile } from 'react-device-detect';

import Drawer from '@mui/material/Drawer';
import { styled, useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';

import SubMenu from '../sidebar/SubMenu';
import { SidebarData } from '../sidebar/SidebarData';
// import Logo from '../../images/perto-logo.png';
import { useHistory } from 'react-router-dom';

export default function MenuSide({ closeMenu, abrir }) {
  const history = useHistory();
  const theme = useTheme();

  const handleDrawerClose = () => {
    closeMenu();
  };

  return (
    <>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: isMobile ? mobileWidth : drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="persistent"
        anchor="left"
        open={abrir}
      >
        <DrawerHeader
          style={{ justifyContent: 'space-between', background: '#3f51b5' }}
        >
          {/* <img
            src={Logo}
            alt=""
            style={{ height: 50, width: 100, margin: 'auto', cursor: 'pointer' }}
            onClick={() => history.push(`/app/dashboard/dashboard`)}
          /> */}
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />

        {/* <List>
          {SidebarData.map((item, index) => {
            return <SubMenu item={item} key={index} />;
          })}
        </List> */}
      </Drawer>
      <Main open={abrir}>
        <DrawerHeader />
      </Main>
    </>
  );
}
const drawerWidth = 240;
const mobileWidth = '100%';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);
